import React, { Component } from 'react';
import { Button } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { ROLE_PROVIDER } from '../../utils/config/constants';
import withCustomTheme from '../HOC/HOCwithCustomTheme.jsx';
class ServicePackage extends Component {
    render() {
        const { data, userData } = this.props;
        const settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false
        };
        if (data.length <= 0) {
            return (
                <p>
                    <FormattedMessage
                        id="service.nopackage"
                        defaultMessage="No package found"
                    />
                </p>
            );
        }
        return (
            <div className="package-slider dir-alp-con-right-1 pl-2">
                {data.map(pack => {
                    return (
                        <div key={pack.key} className="home-list-pop list-spac">
                            <h3>
                                {pack.name}({pack.providerService})
                            </h3>
                            <div className="badge-new" color="success">
                                <FormattedMessage
                                    id="service.price"
                                    defaultMessage="Price"
                                />
                                :{this.props.settings.constants.CURRENCY_SYMBOL}
                                {pack.price}
                            </div>
                            <p> {pack.description} </p>
                            {userData.role != ROLE_PROVIDER && (
                                <Button
                                    className="btn-primary-new"
                                    variant="contained"
                                    color="primary"
                                    onClick={() =>
                                        this.props.clickBookNow(pack, false)
                                    }
                                >
                                    <FormattedMessage
                                        id="prodetail.booknow"
                                        defaultMessage="Book Now"
                                    />
                                </Button>
                            )}
                        </div>
                    );
                })}
            </div>
        );
    }
}
export default withCustomTheme(ServicePackage);



// WEBPACK FOOTER //
// ./src/components/Providers/ServicePackage.js